
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking-lots/[region]/[slug]",
      function () {
        return require("private-next-pages/parking-lots/[region]/[slug]/index.js");
      }
    ]);
  